/* ame-pdp-configure.js — the three-step presentation of the configurator view (sections/ame-pdp-configure.liquid;
   2026-10-16 two-stage product experience). PRESENTATION ONLY: every control stays inside the one product form, and
   assets/ame-pdp-state.js keeps owning prices, selection dependencies, availability, validation and the cart POST.
   What this file does:
     1. tags every row of the steps column with its step — Liquid marks the boundaries (<span data-cfg-step-start="2|3">
        in ame-product-customize); rows before the first marker are Fit & Model, then Options, then Review (quantity, the
        selections list, the order summary with Add to Cart). A step with nothing to choose is dropped from the stepper.
     2. shows one step at a time (class .is-cfg-off — never the `hidden` attribute, which the engine uses to mean "this
        choice does not apply"), with Back / Continue / Cancel, the step in the URL hash (#step-N, so a refresh keeps the
        place and the browser's Back returns to the previous step) and the running total in the header.
     3. Continue checks only the choices the ENGINE marks required on the current step (the same attributes its submit guard
        reads); the engine's own submit guard still runs on Add to Cart, and window.AmePdpHooks.reveal brings the step with
        the offending control back on screen when it reports an error.
     4. builds the Review list from the native controls (product, model, every selected choice with its price or
        "no added cost", each with an Edit link back to its step).
   #all in the URL shows every step at once (used by the release-gate scripts, which exercise the engine, not the stepper). */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp-configure]');
  if (!root) return;
  var panel = root.querySelector('[data-customize-panel]');
  if (!panel) return;
  var main = panel.querySelector('[data-customize-main]');
  var aside = panel.querySelector('[data-customize-aside]');
  var stepsList = root.querySelector('[data-cfg-steps]');
  var nav = root.querySelector('[data-cfg-nav]');
  var H = window.AmePdpHooks = window.AmePdpHooks || {};
  var money = function (cents) { var v = (cents || 0) / 100; return '$' + v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
  var calm = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; };
  var textOf = function (el) { return (el ? (el.innerText || el.textContent || '') : '').replace(/\s+/g, ' ').trim(); };
  var NAMES = { 1: 'Fit & Model', 2: 'Options', 3: 'Review' };
  var NOTES = { 1: 'Choose the model and tell us about the fit. Prices update as you go.', 2: 'Add the options you want. Everything here is optional unless it says Required.', 3: 'Check your selections, set the quantity, then add to cart.' };

  /* running total in the header (all modes) */
  var runTotal = root.querySelector('[data-cfg-running-total]'), runLabel = root.querySelector('[data-cfg-total-label]');
  document.addEventListener('ame:pdp:state', function (e) {
    var d = e.detail || {};
    if (runTotal && typeof d.configuredTotalCents === 'number') runTotal.textContent = money(d.configuredTotalCents);
  });
  if (!main || !stepsList || !nav || root.getAttribute('data-cfg-mode') === 'simple') { root.setAttribute('data-cfg-current', 'review'); return; }

  /* ---- 1. which step owns each row ---- */
  var cur = 1, has = { 1: false, 2: false, 3: true };
  var isContent = function (el) { return el.matches('fieldset, .ame-customize__row, details, [data-option-row], .ame-customize__addons, .ame-customize__qty-row'); };
  Array.prototype.slice.call(main.children).forEach(function (el) {
    var m = el.getAttribute('data-cfg-step-start');
    if (m) { cur = Math.max(cur, parseInt(m, 10) || cur); return; }
    if (el.matches('.ame-customize__reqstatus, .ame-customize__restored, .ame-customize__mount-note')) { el.setAttribute('data-cfg-step', 'all'); return; }
    if (el.classList.contains('ame-customize__qty-row')) cur = 3;
    el.setAttribute('data-cfg-step', String(cur));
    if (cur < 3 && isContent(el)) has[cur] = true;
  });
  var order = [1, 2, 3].filter(function (n) { return has[n]; });
  var idx = function (n) { return order.indexOf(n); };
  Array.prototype.forEach.call(stepsList.querySelectorAll('[data-cfg-step-tab]'), function (li) {
    var n = +li.getAttribute('data-cfg-step-tab'); li.hidden = order.indexOf(n) === -1;
  });
  order.forEach(function (n, i) { var b = stepsList.querySelector('[data-cfg-step-tab="' + n + '"] .ame-cfg__step-n'); if (b) b.textContent = String(i + 1); });
  var title = panel.querySelector('.ame-customize__title');
  var count = document.createElement('p'); count.className = 'ame-cfg__stepcount';
  var note = document.createElement('p'); note.className = 'ame-cfg__stepnote';
  if (title) { title.insertAdjacentElement('beforebegin', count); title.insertAdjacentElement('afterend', note); title.setAttribute('tabindex', '-1'); }
  var qtyRow = main.querySelector('.ame-customize__qty-row');
  var review = document.createElement('div'); review.className = 'ame-cfg__review'; review.setAttribute('data-cfg-step', '3'); review.setAttribute('data-cfg-review', '');
  main.insertBefore(review, qtyRow || null);

  // row + label helpers (shared by the validator and the Review list; defined before the #all branch below builds the list)
  var rowOf = function (el) { return el && el.closest ? (el.closest('[data-option-row], .ame-customize__row, .ame-customize__accessories, .ame-fabric-picker, fieldset') || el) : el; };
  var labelOf = function (el) {
    var row = el && el.closest ? el.closest('fieldset, .ame-customize__row, [data-option-row], details, .ame-fabric-picker') : null;
    var l = row && row.querySelector('legend, .ame-customize__label, .ame-customize__section-head, .ame-acc-head__title');
    return textOf(l).replace(/\s*Required\s*$/i, '').replace(/\s*(Upgrade available|Sizing guide|Compare options|View specifications)\s*$/i, '').trim();
  };
  var allMode = location.hash === '#all';
  if (allMode) { root.setAttribute('data-cfg-all', ''); root.setAttribute('data-cfg-current', 'all'); nav.hidden = true; if (title) title.textContent = 'Customize & Buy'; }

  /* ---- 2. one step at a time ---- */
  var current = null;
  function show(n, opts) {
    opts = opts || {};
    if (order.indexOf(n) === -1) n = order[0];
    current = n;
    if (!allMode) {
      Array.prototype.forEach.call(main.querySelectorAll('[data-cfg-step]'), function (el) {
        var s = el.getAttribute('data-cfg-step'); el.classList.toggle('is-cfg-off', !(s === 'all' || +s === n));
      });
      if (aside) aside.hidden = n !== 3;
    }
    root.setAttribute('data-cfg-current', allMode ? 'all' : (n === 3 ? 'review' : String(n)));
    Array.prototype.forEach.call(stepsList.querySelectorAll('[data-cfg-step-tab]'), function (li) {
      var k = +li.getAttribute('data-cfg-step-tab'), btn = li.querySelector('button');
      li.classList.toggle('is-done', k < n);
      if (k === n) btn.setAttribute('aria-current', 'step'); else btn.removeAttribute('aria-current');
    });
    if (title && !allMode) title.textContent = NAMES[n];
    count.textContent = 'Step ' + (idx(n) + 1) + ' of ' + order.length;
    note.textContent = NOTES[n];
    if (runLabel) runLabel.textContent = n === 3 ? 'Total' : 'Total so far';
    var prev = nav.querySelector('[data-cfg-prev]'), next = nav.querySelector('[data-cfg-next]');
    prev.hidden = idx(n) === 0;
    next.hidden = n === 3;                      // on Review the order summary's Add to Cart is the one action
    if (n === 3) buildReview();
    if (!opts.silent) { try { history[opts.replace ? 'replaceState' : 'pushState']({ cfgStep: n }, '', '#step-' + n); } catch (_) { /* file: / sandbox */ } }
    if (opts.scroll !== false) {
      var top = stepsList || root.querySelector('[data-cfg-body]');
      if (top) top.scrollIntoView({ behavior: calm(), block: 'start' });
      if (title) title.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('ame:cfg:step', { detail: { step: n, index: idx(n) + 1, of: order.length } }));
  }

  /* ---- 3. what still has to be chosen on a step (the engine's own required markers) ---- */
  function problemsIn(n) {
    var out = [];
    var inStep = function (el) { var r = el.closest('[data-cfg-step]'); return !!r && +r.getAttribute('data-cfg-step') === n; };
    Array.prototype.forEach.call(panel.querySelectorAll('[data-addon-required="true"]'), function (el) {
      if (inStep(el) && el.getAttribute('aria-pressed') !== 'true') out.push({ el: el, msg: 'Please choose ' + (el.getAttribute('data-title') || 'this required option') + ' to continue.' });
    });
    Array.prototype.forEach.call(panel.querySelectorAll('select[data-addon-required-group="true"], select[data-required-choice="true"], [data-lineitem-select][data-lineitem-required="true"]'), function (el) {
      if (inStep(el) && !el.value) out.push({ el: el, msg: 'Please choose ' + (el.getAttribute('data-addon-required-label') || el.getAttribute('data-required-choice-label') || el.getAttribute('data-lineitem-label') || labelOf(el) || 'this option').replace(/^an? /i, '') + ' to continue.' });
    });
    var fp = panel.querySelector('[data-fabric-picker]'), fn = panel.querySelector('[data-fabric-selected-name]');
    if (fp && inStep(fp) && !(fn && fn.value)) out.push({ el: fp.querySelector('[data-fabric-picker-trigger]') || fp, msg: 'Select an upholstery option to continue.' });
    Array.prototype.forEach.call(panel.querySelectorAll('.ame-cfg__reconfirm:not(.is-confirmed)'), function (r) {
      if (inStep(r)) out.push({ el: r.querySelector('input:not([type=hidden]), select, button') || r, row: r, msg: 'Please confirm this choice — it could not be restored from your cart.' });
    });
    return out;
  }
  function flag(p) {
    var row = p.row || rowOf(p.el);
    var inline = row.querySelector(':scope > .ame-customize__inline-error');
    if (!inline) { inline = document.createElement('p'); inline.className = 'ame-customize__inline-error'; inline.id = 'ame-cfg-err-' + Math.random().toString(36).slice(2, 8); row.insertBefore(inline, row.firstChild); }
    inline.textContent = p.msg; row.classList.add('is-invalid');
    var target = row.querySelector('.ui-optcard[tabindex="0"], .ui-optcard, input:not([type=hidden]):not([disabled]), select:not([disabled]), button:not([disabled])') || p.el;
    row.scrollIntoView({ behavior: calm(), block: 'center' });
    if (target && target.focus) target.focus({ preventScroll: true });
  }
  function goNext() {
    var p = problemsIn(current);
    if (p.length) { flag(p[0]); return false; }
    var n = order[idx(current) + 1];
    if (n) show(n);
    return true;
  }
  function goTo(k) {
    if (k <= current) { show(k); return; }
    while (current < k) { if (!goNext()) return; }
  }
  nav.querySelector('[data-cfg-next]').addEventListener('click', goNext);
  nav.querySelector('[data-cfg-prev]').addEventListener('click', function () { var n = order[idx(current) - 1]; if (n) show(n); });
  stepsList.addEventListener('click', function (e) { var b = e.target.closest('[data-cfg-goto]'); if (b) goTo(+b.getAttribute('data-cfg-goto')); });
  window.addEventListener('popstate', function (e) {
    if (allMode) return;
    var n = (e.state && e.state.cfgStep) || fromHash();
    if (n && n !== current) show(n, { silent: true, scroll: false });
  });
  function fromHash() { var m = /^#step-(\d)$/.exec(location.hash || ''); return m ? +m[1] : 0; }
  /* an engine validation error that names a control on another step: bring that step back first */
  H.reveal = function (el) {
    if (allMode) return;
    var r = el && el.closest ? el.closest('[data-cfg-step]') : null; if (!r) return;
    var s = r.getAttribute('data-cfg-step');
    if (s !== 'all' && +s !== current) show(+s, { scroll: false });
  };

  /* ---- 4. the Review list ---- */
  var priceOf = function (cents) { cents = parseInt(cents || '0', 10) || 0; return cents > 0 ? '+' + money(cents) : ''; };
  function describe(row) {
    var label = labelOf(row), items = [];
    var push = function (text, price, included, muted) { items.push({ text: text, price: price || '', included: !!included, muted: !!muted }); };
    if (row.matches('[data-variant-cards], [data-axis-cards]')) {
      var r = row.querySelector('input:checked');
      var card = r ? (r.closest('label') || r.nextElementSibling) : null;
      push(textOf(card && card.querySelector('.ame-variant-card__name')) || (r ? r.value : 'Not chosen'), '', false, !r);
    } else if (row.querySelector('[data-addon-radio]')) {
      var rr = row.querySelector('[data-addon-radio]:checked');
      if (rr) push(rr.getAttribute('data-title') || textOf(rr.closest('label')), priceOf(rr.getAttribute('data-price')), !(parseInt(rr.getAttribute('data-price') || '0', 10) > 0));
      else push('Not chosen', '', false, true);
    } else if (row.querySelector('[data-addon-checkbox]')) {
      Array.prototype.forEach.call(row.querySelectorAll('[data-addon-checkbox][aria-pressed="true"]'), function (b) { push(b.getAttribute('data-title') || '', priceOf(b.getAttribute('data-price')), false); });
      if (!items.length) push('None added', '', false, true);
    } else if (row.matches('.ame-fabric-picker') || row.querySelector('[data-fabric-picker]')) {
      var fn = panel.querySelector('[data-fabric-selected-name]'), fc = panel.querySelector('[data-fabric-selected-collection]'), fu = panel.querySelector('[data-fabric-selected-upcharge]');
      label = label || 'Upholstery';
      if (fn && fn.value) push(fn.value + (fc && fc.value ? ' — ' + fc.value : ''), priceOf(fu && fu.value), !(parseInt((fu && fu.value) || '0', 10) > 0)); else push('Not chosen', '', false, true);
    } else {
      var sel = row.querySelector('select');
      if (sel) {
        var o = sel.options[sel.selectedIndex], isAddon = sel.hasAttribute('data-addon-select');
        var t = o ? (o.getAttribute('data-title') || textOf(o).split(' — ')[0]) : '';
        if (!o || o.value === '') push('Not chosen', '', false, true);
        else push(t, isAddon ? priceOf(o.getAttribute('data-price')) : '', isAddon && !(parseInt(o.getAttribute('data-price') || '0', 10) > 0));
      } else {
        var cr = row.querySelector('[data-color-radio]:checked'); if (cr) push(cr.value);
      }
    }
    if (!items.length) return null;
    return { label: label || 'Option', items: items };
  }
  function contentRows(n) {
    var out = [];
    Array.prototype.forEach.call(main.querySelectorAll('[data-cfg-step="' + n + '"]'), function (el) {
      if (el.hasAttribute('data-cfg-review')) return;
      if (el.matches('.ame-customize__addons')) Array.prototype.forEach.call(el.querySelectorAll('.ame-customize__row, fieldset, details'), function (r) { if (!r.closest('.ame-customize__row:not(:scope) , fieldset:not(:scope)') || r.parentElement === el) out.push(r); });
      else if (isContent(el) && !el.classList.contains('ame-customize__qty-row')) out.push(el);
    });
    return out.filter(function (r) { return !r.hidden && !r.closest('[hidden]:not(.ame-customize__aside)'); });
  }
  var rowSeq = 0;
  function buildReview() {
    var img = root.querySelector('.ame-cfg__img'), model = document.querySelector('[data-summary-model]'), sku = root.querySelector('[data-product-sku]');
    var html = '<div class="ame-cfg__review-product">' + (img ? '<img class="ame-cfg__review-img" src="' + escapeHtml(img.currentSrc || img.src) + '" alt="" width="64" height="64">' : '') +
      '<div><p class="ame-cfg__review-kicker">You are configuring</p><p class="ame-cfg__review-name">' + escapeHtml(textOf(model) || root.getAttribute('data-product-title') || '') + '</p>' +
      (sku && !sku.hidden && textOf(sku) ? '<p class="ame-cfg__review-sku">' + escapeHtml(textOf(sku)) + '</p>' : '') + '</div></div>';
    var groups = [];
    [1, 2].forEach(function (n) {
      if (!has[n]) return;
      var rows = contentRows(n).map(function (r) { var d = describe(r); if (!d) return ''; if (!r.id) r.id = 'ame-cfg-row-' + (++rowSeq);
        return '<div class="ame-cfg__review-row"><dt>' + escapeHtml(d.label) + '</dt>' + d.items.map(function (it) {
          return '<dd' + (it.muted ? ' class="ame-cfg__review-muted"' : '') + '>' + escapeHtml(it.text) + (it.price ? '<span class="ame-cfg__review-price">' + escapeHtml(it.price) + '</span>' : (it.included && !it.muted ? '<span class="ame-cfg__review-price ame-cfg__review-price--inc">No added cost</span>' : '')) + '</dd>';
        }).join('') + '<button type="button" class="ame-cfg__review-edit" data-cfg-edit-step="' + n + '" data-cfg-edit-row="' + r.id + '" aria-label="Edit ' + escapeHtml(d.label) + '">Edit</button></div>'; }).join('');
      if (rows) groups.push('<div class="ame-cfg__review-group"><h3 class="ame-cfg__review-h"><span>' + NAMES[n] + '</span><button type="button" class="ame-cfg__review-edit" data-cfg-edit-step="' + n + '">Change</button></h3><dl class="ame-cfg__review-rows">' + rows + '</dl></div>');
    });
    review.innerHTML = html + groups.join('');
  }
  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  review.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cfg-edit-step]'); if (!b) return;
    var n = +b.getAttribute('data-cfg-edit-step'), rowId = b.getAttribute('data-cfg-edit-row');
    show(n, { scroll: !rowId });
    if (rowId) { var r = document.getElementById(rowId); if (r) { r.scrollIntoView({ behavior: calm(), block: 'center' }); var f = r.querySelector('.ui-optcard[tabindex="0"], input:not([type=hidden]):checked, input:not([type=hidden]), select, button, summary'); if (f) f.focus({ preventScroll: true }); } }
  });
  document.addEventListener('ame:pdp:state', function () { if (current === 3 || allMode) buildReview(); });

  /* ---- edit mode support: rows the cart could not vouch for ---- */
  function setReconfirm(rows) {
    rows.forEach(function (row) {
      if (!row || row.classList.contains('ame-cfg__reconfirm')) return;
      row.classList.add('ame-cfg__reconfirm');
      var n = document.createElement('p'); n.className = 'ame-cfg__reconfirm-note'; n.setAttribute('role', 'status');
      n.textContent = 'Please confirm this choice — it could not be restored from your cart exactly as it was.';
      row.insertBefore(n, row.firstChild);
      var done = function () { if (row.classList.contains('is-confirmed')) return; row.classList.add('is-confirmed'); n.textContent = 'Confirmed.'; row.classList.remove('is-invalid'); var ie = row.querySelector(':scope > .ame-customize__inline-error'); if (ie) ie.remove(); };
      row.addEventListener('change', done); row.addEventListener('click', function (e) { if (e.target.closest('input, label, button, select, .ui-optcard, [data-fabric-option]')) done(); });
    });
  }
  function stepOfRow(row) { var r = row.closest('[data-cfg-step]'); var s = r ? r.getAttribute('data-cfg-step') : '1'; return s === 'all' ? 1 : +s; }
  window.AmeCfgSteps = { show: show, current: function () { return current; }, order: order, problemsIn: problemsIn, buildReview: buildReview, setReconfirm: setReconfirm, stepOfRow: stepOfRow, allMode: allMode };

  /* ---- start ---- */
  if (allMode) { current = order[0]; buildReview(); return; }   // after every helper above is defined (the #all branch ran before priceOf/rowSeq existed → 'labelOf is not a function' on the flex-a-bed, gate 2026-10-17)
  var start = fromHash();
  show(order.indexOf(start) !== -1 ? start : order[0], { replace: true, scroll: false });
})();
